'use client';

import { log } from '@repo/telemetry';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@repo/ui/components/ui/card';
import { useEffect } from 'react';
import { RetryButton } from '@/components/route-error';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    log.error('route_error', { digest: error.digest ?? null, error: error.message }, error);
  }, [error]);

  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-6 px-6">
      <Card className="w-full">
        <CardHeader>
          <CardTitle>Something went wrong</CardTitle>
          <CardDescription>We hit an unexpected error. Try again, or refresh the page.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <RetryButton reset={reset} className="w-full" />
          {error.digest && <p className="text-center text-xs text-muted-foreground">Reference: {error.digest}</p>}
        </CardContent>
      </Card>
    </main>
  );
}
